import { render, staticRenderFns } from "./AiQuestionaryBlock.vue?vue&type=template&id=7b9babc0&scoped=true&"
import script from "./AiQuestionaryBlock.vue?vue&type=script&lang=ts&"
export * from "./AiQuestionaryBlock.vue?vue&type=script&lang=ts&"
import style0 from "./AiQuestionaryBlock.vue?vue&type=style&index=0&id=7b9babc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9babc0",
  null
  
)

export default component.exports